import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<CreateMeta @formData={{@model.formData}} @poll={{@model.poll}} />",{ moduleName: "@croodle/client/templates/create/meta.hbs" })